import React from 'react'
import { withTranslation } from 'react-i18next'

import Button from 'app/components/ButtonDefault'
import './styles.scss'

const bc = 'switch-protrack-block'

const SwitchProTrackBlock = ({ t, handleOnClick }) => {
  return (
    <div className={bc}>
      <span className={`${bc}__text`}>{t(`Can't find an action that fits your goals?`)}</span>
      <Button primary onClick={handleOnClick}>
        {t('Switch your ProTrack')}
      </Button>
    </div>
  )
}

export default withTranslation('user')(SwitchProTrackBlock)
